import { useQuery } from '@tanstack/react-query';
import getGiveawaySessionHistory from 'Api/brief-live/getGiveawaySessionHistory';
import getGiveawaySessionHistoryResponse from './model/response/getGiveawaySessionHistoryResponse';

const useGetGiveawaySessionHistory = ({ id, enabled = true }) => {
  return useQuery({
    queryKey: ['giveaway-session-history', id],
    queryFn: async () => {
      const response = await getGiveawaySessionHistory(id);
      return getGiveawaySessionHistoryResponse(response);
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled: enabled && !!id,
  });
};

export default useGetGiveawaySessionHistory;
